import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 256 256",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\" id=\"icon-minus\"><g stroke-width=\"1\" stroke-miterlimit=\"10\"><path d=\"M244.472 137.692H11.242c-5.432 0-9.835-4.404-9.835-9.835s4.403-9.835 9.835-9.835h233.23c5.431 0 9.835 4.403 9.835 9.835s-4.404 9.835-9.835 9.835z\" /><path d=\"M244.472 137.692H11.242c-5.432 0-9.835-4.404-9.835-9.835s4.403-9.835 9.835-9.835h233.23c5.431 0 9.835 4.403 9.835 9.835s-4.404 9.835-9.835 9.835z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol